import { createAsyncType } from '@/store/utils/mutation-types'
import axios from 'axios'
import findIndex from 'lodash/findIndex'

export const types = {
  RESET: 'RESET',
  CHANGE_PAGE: 'CHANGE_PAGE',
  GET_LIST: createAsyncType('GET_LIST'),
  GET_ITEM: createAsyncType('GET_ITEM'),
  UPDATE_ITEM: createAsyncType('UPDATE_ITEM'),
  CREATE_ITEM: createAsyncType('CREATE_ITEM')
}

const PAGINATION_CURRENT_PAGE = 1
const PAGINATION_PER_PAGE = 10
const PAGINATION_TOTAL = 0

export const getDefaultState = (options) => ({
  items: [],
  loading: false,
  descending: false,
  sortBy: null,
  page: PAGINATION_CURRENT_PAGE,
  currentPage: PAGINATION_CURRENT_PAGE,
  perPage: options.perPage || PAGINATION_PER_PAGE,
  total: PAGINATION_TOTAL,
  search: {}
})

export const createResource = (resource, options = {}) => ({
  namespaced: true,

  state: getDefaultState(options),

  mutations: {
    [types.RESET] (state) {
      Object.assign(state, getDefaultState(options))
    },
    [types.CHANGE_PAGE] (state, params) {
      state.page = params.page
    },
    [types.GET_LIST.REQUEST] (state, params) {
      state.loading = true
      state.currentPage = params.page
      state.search = params.search
    },
    [types.GET_LIST.SUCCESS] (state, result) {
      state.items = result.data.items
      state.total = result.data.total
      state.loading = false
    },
    [types.GET_LIST.FAILURE] (state) {
      state.loading = false
    },
    [types.GET_ITEM.REQUEST] (state, params) {
      state.loading = true
    },
    [types.GET_ITEM.SUCCESS] (state, result) {
      state.items = [result.data]
      state.total = 1
      state.loading = false
    },
    [types.GET_ITEM.FAILURE] (state) {
      state.loading = false
    },
    [types.UPDATE_ITEM.REQUEST] (state) {
      state.loading = true
    },
    [types.UPDATE_ITEM.SUCCESS] (state, result) {
      let indexOfItem = findIndex(state.items, item => item._id === result.data._id)
      if (indexOfItem !== -1) {
        state.items[indexOfItem] = result.data
      }
      state.loading = false
    },
    [types.UPDATE_ITEM.FAILURE] (state) {
      state.loading = false
    },
    [types.CREATE_ITEM.REQUEST] (state) {
      state.loading = true
    },
    [types.CREATE_ITEM.SUCCESS] (state, result) {
      state.items.push(result.data)
      state.loading = false
    },
    [types.CREATE_ITEM.FAILURE] (state) {
      state.loading = false
    }
  },

  actions: {

    async changePage ({ commit }, page) {
      commit(types.CHANGE_PAGE, { page })
    },

    async getList ({ commit }, { page = 1, perPage, sf, so, search = {} }) {
      commit(types.GET_LIST.REQUEST, { page, perPage, search })
      try {
        const result = await axios.get(`/api/${resource}`, { params: { l: perPage, lo: (page - 1), sf, so, ...search } })
        commit(types.GET_LIST.SUCCESS, result)
      } catch (err) {
        commit(types.GET_LIST.FAILURE)
      } finally {
      }
    },

    async getItem ({ commit }, { id }) {
      commit(types.GET_ITEM.REQUEST, { id })
      try {
        commit(types.GET_ITEM.SUCCESS, await axios.get(`/api/${resource}/${id}`, {}))
      } catch (err) {
        commit(types.GET_ITEM.FAILURE)
      } finally {
      }
    },

    async updateItem ({commit}, {id, item}) {
      commit(types.UPDATE_ITEM.REQUEST)
      try {
        commit(types.UPDATE_ITEM.SUCCESS, await axios.put(`/api/${resource}/${id}`, item))
      } catch (e) {
        commit(types.UPDATE_ITEM.FAILURE)
      }
    },

    async createItem ({commit}, {item}) {
      commit(types.CREATE_ITEM.REQUEST)
      try {
        commit(types.CREATE_ITEM.SUCCESS, await axios.post(`/api/${resource}`, item))
      } catch (e) {
        commit(types.CREATE_ITEM.FAILURE)
      }
    },

    reset ({commit}) {
      commit(types.RESET)
    }

  },

  getters: {
    getById: state => id => {
      return state.items.find(o => o._id === id)
    }
  }
})
